import { useTranslation } from 'react-i18next';
import CentrosBase from './CentrosBase';

const Revendedores = () => {

    const { t } = useTranslation();

    return (
        <CentrosBase centroNome={'PONTO DE VENDA'} 
        centroDescricao={t('CentrosBase.revendedorDescricao')} 
        tipo={'REVENDEDOR'} 
        excludedCountries={['PERU', 'URUGUAI']}/>
    );
};

export default Revendedores;